namespace GeniuzPOS.Inventory {
    export interface IcStockWhsRow {
        Id?: number;
        SkuCode?: string;
        SkuWhsIdCode?: string;
        QtyOnhand?: number;
        StockCostValue?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace IcStockWhsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'Inventory.IcStockWhs';
        export const deletePermission = '2Inventory:ประมวลผลสต๊อก:Modify';
        export const insertPermission = '2Inventory:ประมวลผลสต๊อก:Modify';
        export const readPermission = '2Inventory:ประมวลผลสต๊อก:View';
        export const updatePermission = '2Inventory:ประมวลผลสต๊อก:Modify';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            SkuWhsIdCode = "SkuWhsIdCode",
            QtyOnhand = "QtyOnhand",
            StockCostValue = "StockCostValue",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
